document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.main-menu > li.mega-menu header-menu').forEach(function (el) {
    var details = el.querySelector('details');
    if (!details) return;
    var summary = details.querySelector('summary');
    var closeTimer = null;

    function openMenu() {
      if (window.innerWidth <= 1024) return;
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }

    el.addEventListener('mouseenter', openMenu);

    el.addEventListener('mouseleave', function () {
      if (window.innerWidth <= 1024) return;
      closeTimer = setTimeout(closeMenu, 250);
    });

    if (summary) {
      // On desktop, hover already controls open/close - a click on the
      // trigger would otherwise toggle the native <details> closed again.
      summary.addEventListener('click', function (event) {
        if (window.innerWidth <= 1024) return;
        event.preventDefault();
      });
    }
  });
});
